export enum AdvertisementTypeEnum {
  VEHICLE_SALE = 'VEHICLE_SALE_ADVERTISEMENT',
  PART_SALE = 'PART_SALE_ADVERTISEMENT',
  RENT = 'RENT_ADVERTISEMENT',
  LEASE = 'LEASE_ADVERTISEMENT',
  SERVICE = 'SERVICE_ADVERTISEMENT',
}
